<template>
  <div class="timetable1">
    <Header  title="实践课程表" ></Header>
    <div class="timetable_top1">
      <van-field
        readonly
        clickable
        placeholder="周次"
        v-model="curWeek"
        @click="
          showPicker = true;
          change = false;
        "
      />    
      <i class="week-arrow"></i>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
          :item-height="35"
          :default-index="defaultIndex"
        />
      </van-popup>

      <div class="time-right">
        <div class="currentTime" @click="fn1(nowzc, undefined)">今</div>
      </div>
    </div>
    <div class="timetable_list">
      <div class="period" style="margin-bottom: 70px">
        <div >
          {{ this.weekday }}<br />月
        </div>
        <ul v-if="schoolCode == '10762'">
          <li
            style="width: 62px;height: 131px;line-height: 131px;"
            v-for="(item, index) in nodeList"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
        <ul v-else>
          <li v-for="(item, index) in nodeList" :key="index">
            {{ item.nodeNumber }}
          </li>
        </ul>
      </div>
      <div class="table-right">
        <div class="week-nav">
          <ul>
            <li
              :style="
                curDay == '星期' + item.xqmc && nowzc == item.zc
                  ? 'background-color:#12DDD6'
                  : ''
              "
              v-for="(item, index) in dateWeekList"
              :key="index"
            >
              <span>周{{ item.xqmc }}</span>
              <p v-if="item.zc != 'all'">{{ dateSub(item.mxrq) }}</p>
            </li>
          </ul>
        </div>
        <div class="course-content">
          <!-- 周日 -->
          <div class="course-form" id="Sunday">
            <ul class="myul">
              <template v-for="(list, active) in SundayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          <span v-if="schoolCode == '14345' || schoolCode == '12989'"
                            >-{{ item.ktmc }}</span
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周一 -->
          <div class="course-form" id="monday">
            <ul class="myul">
              <template v-for="(list, active) in mondayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 1,num)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                          >
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周二 -->
          <div class="course-form" id="Tuesday">
            <ul class="myul">
              <template v-for="(list, active) in TuesdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周三 -->
          <div class="course-form" id="Wednesday">
            <ul class="myul">
              <template v-for="(list, active) in WednesdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 1,num)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周四 -->
          <div class="course-form" id="Thursday">
            <ul class="myul">
              <template v-for="(list, active) in ThursdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周五 -->
          <div class="course-form" id="Friday">
            <ul class="myul">
              <template v-for="(list, active) in FridayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 1,num)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <!-- 周六 -->
          <div class="course-form" id="Saturday">
            <ul class="myul">
              <template v-for="(list, active) in SaturdayList">
                <template v-for="(elem, num) in list">
                  <li
                    ref="ranText"
                    :style="
                      elem[0].courseName
                        ? 'top:' +
                          calcOpt(elem[0].weekNoteDetail, 0) +
                          'height:' +
                          calcOpt(elem[0].weekNoteDetail, 1)
                        : ''
                    "
                    @click="courseDetail(elem)"
                    :key="active + num"
                  >
                    <van-swipe
                      class="my-swipe"
                      :autoplay="0"
                      indicator-color="white"
                      :loop="false"
                      @change="
                        index => {
                          return onChange(index, elem);
                        }
                      "
                    >
                      <van-swipe-item
                        v-for="(item, index) in elem"
                        :key="index"
                        :style="
                          item.courseName
                            ? 'background-color:' + calcColor(index, 0,num)
                            : ''
                        "
                      >
                        <span v-show="item.courseName"
                          >{{ item.courseName }} - {{ item.teacherName }} @
                          {{ item.classroomName }}
                        </span>
                        <span v-show="!item.courseName"></span>
                        <p
                          v-if="item.buttonCode != 0"
                          v-text="
                            item.buttonCode == 2 ? '进入课堂' : '创建课堂'
                          "
                        ></p>
                      </van-swipe-item>
                      <template #indicator>
                        <div v-if="elem.length > 1" class="custom-indicator">
                          {{ elem.current + 1 }}/{{ elem.length }}
                        </div>
                      </template>
                    </van-swipe>
                  </li>
                </template>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="popShow" class="popup">
      <h2>
        <i class="close-pop" @click="popShow = false"></i>
      </h2>
      <div
        class="popup-content"
        v-for="(item, index) in this.popList"
        :key="index"
      >
        <p>
          课程名称：<span>{{ item.courseName }}</span>
        </p>
        <p
        >
        </p>
        <p>
          地点：<span>{{ item.classroomName }}</span>
        </p>
        <p>
          教师：<span>{{ item.teacherName }}</span>
        </p>
          <p>
            上课班级：<span>{{ item.ktmc }}</span>
          </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "../../../utils/axios";
export default {
  data() {
    return {
      isInJxzl:"0",
      BottomDiv: "",
      schoolCode: "",
      casLogin: sessionStorage.getItem("casLogin"),
      isAllow: "",
      timetable: [],
      infoWeek: "",
      popShow: false,
      popShow_student: false,
      popList: [],
      defaultIndex: 0,
      defaultIndex1: 0,
      curWeek: "",
      timeMode: "",
      showPicker: false,
      modePicker: false,
      modeColumns: [],
      modeIdColumns: [],
      timeModeId: "",
      columns: [
        {
          values: [],
          className: "column1"
        }
      ],
      zcList: [],
      zc: "",
      nowzc: "",
      curDay: "",
      allCourseList: [],
      mondayList: [],
      TuesdayList: [],
      WednesdayList: [],
      ThursdayList: [],
      FridayList: [],
      SaturdayList: [],
      SundayList: [],
      nodeList: [],
      weekday: "",
      isShow: true,
      needClassName:false,
      needClassRoomNub:false,
      dateWeekList: [],
      colorList: ["#FF8282", "#EE7BFF", "#FFBB79", "#FF87B3", "#86B5FF"],
      colorList1: [
        "rgba(118,107,255,.7)",
        "#757DA3",
        "rgba(255,84,147,.4)",
        "#B3B9D0",
        "rgba(95,222,255,.7)"
      ],
      updateUrl: "",
      change: true,
      studentsList: [],
      buttonCodeFlag:'0',
      jgxxColumns: [],
      jgxm:'',
      jgid:''
    };
  },
  methods: {
    onChange(index, elem) {
      elem.current = index;
    },
    calcColor(index, type, active) {
      index = index + active;
      let num = Math.abs(index - 2) % 5;
      let num1 = Math.abs(index - 4) % 5;
      if (this.change) {
        if (type == 0) {
          return this.colorList[num];
        } else {
          return this.colorList1[num1];
        }
      }
    },
    modeConfirm(val, index) {
      this.modePicker = false;
      this.timeMode = val;
      this.timeModeId = this.modeIdColumns[index];
      this.fn1(this.zc, this.modeIdColumns[index]);
    },
    async courseDetail(arr) {
      let info = arr[0];
      this.change = false;
      switch (info.weekDay) {
        case "1":
          this.infoWeek = "周一";
          break;
        case "2":
          this.infoWeek = "周二";
          break;
        case "3":
          this.infoWeek = "周三";
          break;
        case "4":
          this.infoWeek = "周四";
          break;
        case "5":
          this.infoWeek = "周五";
          break;
        case "6":
          this.infoWeek = "周六";
          break;
        case "7":
          this.infoWeek = "周日";
          break;
        default:
          break;
      }
      this.popShow = true;
      this.popList = arr;
      this.buttonCodeFlag = arr[0].buttonCode;
      this.infoWeek = this.infoWeek + "，" + info.weekNoteDetail;
      const params = {
        coursePlanId: info.coursePlanId
      };
    },
    dateSub(res) {
      return Number(res.substr(-2, 2));
    },
    calcOpt(val, type) {
      let num = Number(val.substr(1, 2)) - 1;
      //top
      if (type == 0) {
        return num * 70 + "px;";
        //height
      } else {
        return ((val.length+1)/4*70-1)+"px";
      }
    },
    async onConfirm(value, index) {
      this.change = true;
      this.allCourseList = [];
      this.mondayList = [];
      this.TuesdayList = [];
      this.WednesdayList = [];
      this.ThursdayList = [];
      this.FridayList = [];
      this.SaturdayList = [];
      this.SundayList = [];

      let mondayList = [];
      let TuesdayList = [];
      let WednesdayList = [];
      let ThursdayList = [];
      let FridayList = [];
      let SaturdayList = [];
      let SundayList = [];
      this.curWeek = value.toString();

      this.zc = this.zcList[index];
      this.showPicker = false;
      const params = {
        week: this.zc,
      };
      
      const res = await Api.teachCourseSchedule_pra(params);
      if (res.data.length == 0) {
        this.$toast.fail(res.Msg);
      } else {
        if (res.data[0].courses.length == 0) {
          this.$toast.fail(res.Msg);
        }
        this.dateWeekList = res.data[0].date;
        this.nodeList = res.data[0].nodes;
        this.weekday = Number(res.data[0].date[0].mxrq.substr(5, 2));
        this.curDay = res.data[0].topInfo[0].weekday;
        this.allCourseList = res.data[0].courses;
        for (let i of this.allCourseList) {
          for (let j of i) {
            j.current = 0;
          }
        }
        //周一
        mondayList.push(this.allCourseList[0]);
        //周二
        TuesdayList.push(this.allCourseList[1]);
        //周三
        WednesdayList.push(this.allCourseList[2]);
        //周四
        ThursdayList.push(this.allCourseList[3]);
        //周五
        FridayList.push(this.allCourseList[4]);
        //周六
        SaturdayList.push(this.allCourseList[5]);
        //周日
        SundayList.push(this.allCourseList[6]);
        
        let calStart = res.data[0].date[0].xqmc;
        if (calStart == "日") {
          this.mondayList = mondayList;
          this.TuesdayList = TuesdayList;
          this.WednesdayList = WednesdayList;
          this.ThursdayList = ThursdayList;
          this.FridayList = FridayList;
          this.SaturdayList = SaturdayList;
          this.SundayList = SundayList;
        } else if (calStart == "一") {
          this.mondayList = TuesdayList;
          this.TuesdayList = WednesdayList;
          this.WednesdayList = ThursdayList;
          this.ThursdayList = FridayList;
          this.FridayList = SaturdayList;
          this.SaturdayList = SundayList;
          this.SundayList = mondayList;
        } else if (calStart == "二") {
          this.mondayList = WednesdayList;
          this.TuesdayList = ThursdayList;
          this.WednesdayList = FridayList;
          this.ThursdayList = SaturdayList;
          this.FridayList = SundayList;
          this.SaturdayList = mondayList;
          this.SundayList = TuesdayList;
        } else if (calStart == "三") {
          this.mondayList = ThursdayList;
          this.TuesdayList = FridayList;
          this.WednesdayList = SaturdayList;
          this.ThursdayList = SundayList;
          this.FridayList = mondayList;
          this.SaturdayList = TuesdayList;
          this.SundayList = WednesdayList;
        } else if (calStart == "四") {
          this.mondayList = FridayList;
          this.TuesdayList = SaturdayList;
          this.WednesdayList = SundayList;
          this.ThursdayList = mondayList;
          this.FridayList = TuesdayList;
          this.SaturdayList = WednesdayList;
          this.SundayList = ThursdayList;
        } else if (calStart == "五") {
          this.mondayList = SaturdayList;
          this.TuesdayList = SundayList;
          this.WednesdayList = mondayList;
          this.ThursdayList = TuesdayList;
          this.FridayList = WednesdayList;
          this.SaturdayList = ThursdayList;
          this.SundayList = FridayList;
        } else if (calStart == "六") {
          this.mondayList = SundayList;
          this.TuesdayList = mondayList;
          this.WednesdayList = TuesdayList;
          this.ThursdayList = WednesdayList;
          this.FridayList = ThursdayList;
          this.SaturdayList = FridayList;
          this.SundayList = SaturdayList;
        }
      }
    },
    async fn1(val, e) {

        if(this.isInJxzl!="1"){
            this.$toast.fail("当前日期不在系统设置的当前学期的教学周历范围内!");
            return;
        }
      this.allCourseList = [];
      this.mondayList = [];
      this.TuesdayList = [];
      this.WednesdayList = [];
      this.ThursdayList = [];
      this.FridayList = [];
      this.SaturdayList = [];
      this.SundayList = [];

      let mondayList = [];
      let TuesdayList = [];
      let WednesdayList = [];
      let ThursdayList = [];
      let FridayList = [];
      let SaturdayList = [];
      let SundayList = [];
      const params = {
        week: val,
      };
      const res = await Api.teachCourseSchedule_pra(params);
      if (res.data.length == 0) {
        this.$toast.fail(res.Msg);
        return;
      } else {
        if (res.data[0].courses && res.data[0].courses.length == 0) {
          this.$toast.fail(res.Msg);
          return;
        }
      }
      this.nodeList = res.data[0].nodes;
      if(val!=''){
        this.curWeek = "第" + val + "周";
      }
    
      this.weekday = res.data[0].topInfo[0].today.slice(5, 7);
      this.curDay = res.data[0].topInfo[0].weekday;
      this.allCourseList = res.data[0].courses;
      this.dateWeekList = res.data[0].date;

      for (let i of this.allCourseList) {
        for (let j of i) {
          j.current = 0;
        }
      }
      //周一
      mondayList.push(this.allCourseList[0]);
      //周二
      TuesdayList.push(this.allCourseList[1]);
      //周三
      WednesdayList.push(this.allCourseList[2]);
      //周四
      ThursdayList.push(this.allCourseList[3]);
      //周五
      FridayList.push(this.allCourseList[4]);
      //周六
      SaturdayList.push(this.allCourseList[5]);
      //周日
      SundayList.push(this.allCourseList[6]);
      let calStart = res.data[0].date[0].xqmc;
      if (calStart == "日") {
        this.mondayList = mondayList;
        this.TuesdayList = TuesdayList;
        this.WednesdayList = WednesdayList;
        this.ThursdayList = ThursdayList;
        this.FridayList = FridayList;
        this.SaturdayList = SaturdayList;
        this.SundayList = SundayList;
      } else if (calStart == "一") {
        this.mondayList = TuesdayList;
        this.TuesdayList = WednesdayList;
        this.WednesdayList = ThursdayList;
        this.ThursdayList = FridayList;
        this.FridayList = SaturdayList;
        this.SaturdayList = SundayList;
        this.SundayList = mondayList;
      } else if (calStart == "二") {
        this.mondayList = WednesdayList;
        this.TuesdayList = ThursdayList;
        this.WednesdayList = FridayList;
        this.ThursdayList = SaturdayList;
        this.FridayList = SundayList;
        this.SaturdayList = mondayList;
        this.SundayList = TuesdayList;
      } else if (calStart == "三") {
        this.mondayList = ThursdayList;
        this.TuesdayList = FridayList;
        this.WednesdayList = SaturdayList;
        this.ThursdayList = SundayList;
        this.FridayList = mondayList;
        this.SaturdayList = TuesdayList;
        this.SundayList = WednesdayList;
      } else if (calStart == "四") {
        this.mondayList = FridayList;
        this.TuesdayList = SaturdayList;
        this.WednesdayList = SundayList;
        this.ThursdayList = mondayList;
        this.FridayList = TuesdayList;
        this.SaturdayList = WednesdayList;
        this.SundayList = ThursdayList;
      } else if (calStart == "五") {
        this.mondayList = SaturdayList;
        this.TuesdayList = SundayList;
        this.WednesdayList = mondayList;
        this.ThursdayList = TuesdayList;
        this.FridayList = WednesdayList;
        this.SaturdayList = ThursdayList;
        this.SundayList = FridayList;
      } else if (calStart == "六") {
        this.mondayList = SundayList;
        this.TuesdayList = mondayList;
        this.WednesdayList = TuesdayList;
        this.ThursdayList = WednesdayList;
        this.FridayList = ThursdayList;
        this.SaturdayList = FridayList;
        this.SundayList = SaturdayList;
      }
    },
    async loadClass() {
      const params = {
        week: ""
      };
       const res = await Api.teachCourseSchedule_pra(params);
      if (res.data.length == 0) {
        this.$toast.fail(res.Msg);
        if (res.code == "0") {
          this.$toast.fail(res.Msg);
          setTimeout(() => {
            // this.$router.replace('/homeIndex')
          }, 2000);
        }
      } else {
        if (res.data[0].courses.length == 0) {
          this.$toast.fail(res.Msg);
        }
        this.nodeList = res.data[0].nodes;
        this.isInJxzl=res.data[0].topInfo[0].isInJxzl;
            if(this.isInJxzl=="0"){
                this.curWeek = "第1周";
                this.nowzc = '1';
                this.weekday = res.data[0].date[0].mxrq.slice(5, 7);
            }
            if(this.isInJxzl=="1"){
                this.curWeek = "第" + res.data[0].topInfo[0].week + "周";
                this.nowzc = res.data[0].topInfo[0].week;
                this.weekday = res.data[0].topInfo[0].today.slice(5, 7);
            }
        this.defaultIndex = Number(res.data[0].topInfo[0].week) - 1;
        this.curDay = res.data[0].topInfo[0].weekday;
        this.allCourseList = res.data[0].courses;
        this.dateWeekList = res.data[0].date;

        let mondayList = [];
        let TuesdayList = [];
        let WednesdayList = [];
        let ThursdayList = [];
        let FridayList = [];
        let SaturdayList = [];
        let SundayList = [];
        for (let i of this.allCourseList) {
          for (let j of i) {
            j.current = 0;
          }
        }
        //周一
        mondayList.push(this.allCourseList[0]);
        //周二
        TuesdayList.push(this.allCourseList[1]);
        //周三
        WednesdayList.push(this.allCourseList[2]);
        //周四
        ThursdayList.push(this.allCourseList[3]);
        //周五
        FridayList.push(this.allCourseList[4]);
        //周六
        SaturdayList.push(this.allCourseList[5]);
        //周日
        SundayList.push(this.allCourseList[6]);

        let calStart = res.data[0].date[0].xqmc;
        if (calStart == "日") {
          this.mondayList = mondayList;
          this.TuesdayList = TuesdayList;
          this.WednesdayList = WednesdayList;
          this.ThursdayList = ThursdayList;
          this.FridayList = FridayList;
          this.SaturdayList = SaturdayList;
          this.SundayList = SundayList;
        } else if (calStart == "一") {
          this.mondayList = TuesdayList;
          this.TuesdayList = WednesdayList;
          this.WednesdayList = ThursdayList;
          this.ThursdayList = FridayList;
          this.FridayList = SaturdayList;
          this.SaturdayList = SundayList;
          this.SundayList = mondayList;
        } else if (calStart == "二") {
          this.mondayList = WednesdayList;
          this.TuesdayList = ThursdayList;
          this.WednesdayList = FridayList;
          this.ThursdayList = SaturdayList;
          this.FridayList = SundayList;
          this.SaturdayList = mondayList;
          this.SundayList = TuesdayList;
        } else if (calStart == "三") {
          this.mondayList = ThursdayList;
          this.TuesdayList = FridayList;
          this.WednesdayList = SaturdayList;
          this.ThursdayList = SundayList;
          this.FridayList = mondayList;
          this.SaturdayList = TuesdayList;
          this.SundayList = WednesdayList;
        } else if (calStart == "四") {
          this.mondayList = FridayList;
          this.TuesdayList = SaturdayList;
          this.WednesdayList = SundayList;
          this.ThursdayList = mondayList;
          this.FridayList = TuesdayList;
          this.SaturdayList = WednesdayList;
          this.SundayList = ThursdayList;
        } else if (calStart == "五") {
          this.mondayList = SaturdayList;
          this.TuesdayList = SundayList;
          this.WednesdayList = mondayList;
          this.ThursdayList = TuesdayList;
          this.FridayList = WednesdayList;
          this.SaturdayList = ThursdayList;
          this.SundayList = FridayList;
        } else if (calStart == "六") {
          this.mondayList = SundayList;
          this.TuesdayList = mondayList;
          this.WednesdayList = TuesdayList;
          this.ThursdayList = WednesdayList;
          this.FridayList = ThursdayList;
          this.SaturdayList = FridayList;
          this.SundayList = SaturdayList;
        }
      }
    },
    async getWeek() {
      let concatList1 = [];
      let concatList2 = [];
      const params = {
        semester: ""
      };
      const res = await Api.getTeachingWeek(params);
      for (let i = 0; i < res.data.length; i++) {
        concatList1 = concatList1.concat("第" + res.data[i].week + "周");
        concatList2 = concatList2.concat(res.data[i].week);
      }
      this.columns[0].values = concatList1;
      this.zcList = concatList2;
    }
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.loadClass();
    //教学周次
    this.getWeek();
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.ranText) {
        for (let i = 0; i < this.$refs.ranText.length; i++) {
          if (
            this.$refs.ranText[i].children &&
            this.$refs.ranText[i].children.length == 3
          ) {
            this.$refs.ranText[i].children[2].style.color = this.$refs.ranText[
              i
            ].style.backgroundColor;
          }
        }
      }
    }, 250);
  }
};
</script>

<style lang="less" scoped>
.footerparndiv {
  display: flex;
  flex-direction: row;
  height: 7rem;
  width: 100%;
  .bottomleftdiv {
    display: block;
    line-height: 3rem;
    color: #757dac;
    p {
      margin-left: 10px;
    }
    //  border-right: 0.3px solid #D0D4E5;
    width: 20%;
    height: 4rem;
    margin-bottom: 3rem;
    background-color: #f4f5ff;
  }
  .bottomrightdiv {
    display: block;
    width: 80%;
    color: red;
    font-size: 10px;
    height: 4rem;
    margin-bottom: 3rem;
    background-color: #f4f5ff;
  }
}

.timetable1 {
  .timetable_top1 {
    /deep/.van-field__control {
      color: #ffffff;
    }
  }
  .popup {
    i.close-pop {
      background: url(../../../../static/img/close.png) no-repeat center;
      position: absolute;
      right: 10px;
      top: 10px;
      background-size: 20px 20px;
      width: 20px;
      height: 20px;
      padding: 10px;
    }
  }
  .link-item {
    text-decoration: underline;
    word-break: break-all;
  }
}
.timetable1 .van-popup.van-popup--center {
  box-sizing: border-box;
  padding: 40px 20px 20px;
  width: 90%;
  border-radius: 5px;
}
.timetable1 .van-popup.van-popup--center .popup-content {
  margin-bottom: 20px;
}
.timetable1 .van-popup.van-popup--center .popup-content > h2 {
  color: @attendance-color-1;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
}
.timetable1 .van-popup.van-popup--center .popup-content > div {
  color: @attendance-background-color-1;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
.timetable1 .van-popup.van-popup--center .popup-content > p {
  color: @attendance-color-2;
  font-size: 16px;
  line-height: 30px;
}
.timetable1 .popup button {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
  padding: 11px 0;
  border-radius: 3px;
  width: 100%;
  margin-top: 50px;
}
.timetable1 .van-popup.van-popup--center .popup-content > p > span {
  font-weight: bold;
}
.timetable1 .timetable_top1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: @attendance-background-color-1;
  padding: 10px 15px;
}
.timetable1 .timetable_top1 select {
  color: @attendance-color-3;
  border: 0;
  background: none;
  outline: none;
}
.timetable1 .timetable_top1 .currentTime {
  width: 25px;
  height: 25px;
  line-height: 25px;
  font-weight: 300;
  color: @attendance-color-3;
  font-size: 14px;
  text-align: center;
  border-radius: 50%;
  background: @attendance-background-color-8;
}
.timetable1 .timetable_list {
  display: flex;
  background-color: @attendance-background-color-6;
}
.timetable1 .timetable_list .period > div {
  border: 1px solid @attendance-border-color-5;
  border-bottom: 0;
  box-sizing: border-box;
  font-size: 14px;
  text-align: center;
  box-shadow: 1px 1px 4px 0px rgba(62, 53, 167, 0.26);
  background: @attendance-border-color-5;
  color: @attendance-color-3;
  box-shadow: 1px 1px 4px 0px rgba(62, 53, 167, 0.26);
  height: 60px;
  width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.timetable1 .timetable_list .period ul li {
  height: 70px;
  text-align: center;
  line-height: 70px;
}
.timetable1 .el-tabs__nav .is-top {
  background: @attendance-border-color-5;
  color: @attendance-color-3;
}
.timetable1 .table_list ul li {
  width: 62px;
  height: 115px;
  background: @attendance-background-color-9;
  color: @attendance-color-3;
  box-sizing: border-box;
  padding: 5px;
  font-size: 12px;
  border-radius: 2px;
}
.timetable1 .timetable_top1 .van-cell {
  background-color: @attendance-background-color-1 !important;
  color: @attendance-color-3;
  padding: 0;
  width: 15%;
}
.timetable1 .timetable_top1 .van-field__body .van-field__control {
  color: @attendance-color-3 !important;
}
.timetable1 .timetable_top1 .van-cell:not(:last-child)::after {
  border-bottom: 0;
}
.timetable1 .week-arrow {
  background: url(../../../../static/img/week.png) no-repeat center;
  width: 7px;
  height: 4px;
  background-size: 7px 4px;
  position: absolute;
  left: 70px;
}
.timetable1
  .timetable1
  .timetable_top1
  .van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}
.timetable1 .table-right {
  flex: 1;
  overflow-x: scroll;
}
.timetable1 .table-right .week-nav ul li {
  flex-direction: column;
  height: 60px;
  background-color: @attendance-border-color-5;
  color: @attendance-color-3;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
}
.timetable1 .table-right .week-nav ul li > p {
  font-size: 14px;
  margin-top: 3px;
}
.timetable1 .table-right .week-nav ul {
  display: flex;
  border-bottom: 1px solid @attendance-color-3;
  min-width: 435px;
  max-width: 100%;
}
.timetable1 .el-tabs__nav {
  width: 100%;
}
.timetable1 .period ul li {
  color: @attendance-color-2;
}
.timetable1 .course-content {
  display: flex;
  min-width: 435px;
  max-width: 100%;
}
.timetable1 .course-form {
  width: 15%;
  position: relative;
}
.timetable1 .course-form ul {
  display: flex;
  flex-direction: column;
}
.timetable1 .course-form .myul {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  border-right: 1px solid @attendance-color-3;
}
.timetable1 .course-form .myul li {
  overflow: hidden;
  width: calc(~"100% - 1px");
  position: relative;
  height: 139px;
  color: @attendance-color-3;
  font-size: 12px;
  margin-bottom: 1px;
  border-radius: 4px;
  position: absolute;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* -webkit-line-clamp: 8; */
  box-sizing: border-box;
  margin-right: 1px;
}
.timetable1 .course-form .myul li > p {
  border-radius: 9px;
  background-color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  text-align: center;
  padding: 2px 0;
  position: absolute;
  bottom: 4px;
  left: 2px;
  width: calc(~"100% - 4px");
  box-sizing: border-box;
  line-height: 14px;
}
.timetable1 .pos_item {
  position: absolute;
  top: 0;
  left: -9px;
}
.timetable1 .pos_item li {
  width: 58px;
  height: 65px;
  color: @attendance-color-3;
  margin-bottom: 1px;
  border-radius: 4px 4px 4px 4px;
  font-size: 12px;
  padding: 4px;
}
/* 时间模式 */
.time-right {
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.time-right .van-cell {
  width: calc(~"80% - 25px") !important;
}
.time-right .van-field__control {
  text-align: right;
  padding-right: 25px;
}
.time-right i.week-arrow {
  right: 35px;
  left: unset;
  height: 100%;
}

.popup_student {
  i.close-pop {
    background: url(../../../../static/img/close.png) no-repeat center;
    position: absolute;
    right: 0;
    top: -10px;
    background-size: 20px 20px;
    width: 20px;
    height: 20px;
    padding: 10px;
  }
}
.set-part {
  display: flex;
  justify-content: space-between;
}
.set-part > div {
  width: 48%;
}
.set-part-p {
  text-align: left;
}
.timetable1 .ul-student {
  width: 99%;
}
.timetable1 .li-student {
  width: 33%;
  float: left;
  font-size: 15px;
}
.student-tittle-div {
  margin-top: -10px;
}
.student-context-div {
  margin: 0px;
}
.li-student-context {
  width: 33%;
  float: left;
  font-size: 12px;
  color: black;
}
.ul-student-context {
  width: 99%;
  line-height: 20px;
}
.div-backclor1 li {
  background-color: gainsboro;
}
.div-backclor2 li {
  background-color: antiquewhite;
}
.my-swipe {
  width: 100%;
  height: 100%;
  .van-swipe-item {
    padding: 8px 4px;
    box-sizing: border-box;
    color: #fff;
    margin-right: 1px;
  }
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Class/practiceSurfaces.vue